import { useState, type ReactNode } from 'react'
import { createPortal } from 'react-dom'

/**
 * **Ein Tooltip, der nicht abgeschnitten wird** – für die schmale Seitenleiste. Die Leiste scrollt
 * (`overflow-y-auto`), ein Tooltip darin würde an ihrem Rand abgeschnitten; deshalb steht er über
 * ein Portal am Fenster, rechts neben dem Element.
 */
export function Tipp({ text, an, children }: { text: string; an: boolean; children: ReactNode }) {
  const [ort, setOrt] = useState<{ x: number; y: number } | null>(null)
  if (!an) return <>{children}</>
  return (
    <div
      onMouseEnter={(e) => {
        const r = e.currentTarget.getBoundingClientRect()
        setOrt({ x: r.right + 8, y: r.top + r.height / 2 })
      }}
      onMouseLeave={() => setOrt(null)}
      onFocus={(e) => {
        const r = e.currentTarget.getBoundingClientRect()
        setOrt({ x: r.right + 8, y: r.top + r.height / 2 })
      }}
      onBlur={() => setOrt(null)}
    >
      {children}
      {ort &&
        createPortal(
          <div
            role="tooltip"
            className="pointer-events-none fixed z-[60] -translate-y-1/2 rounded-md bg-ink px-2 py-1 text-[12px] font-medium whitespace-nowrap text-white shadow"
            style={{ left: ort.x, top: ort.y }}
          >
            {text}
          </div>,
          document.body,
        )}
    </div>
  )
}
